import styled from 'styled-components';
import { isMobile } from '../../../common/utils';

const namespace = 'responsable';

export const StyledUserAssignedContainer = styled.div`
  display: -webkit-inline-box;
  align-items: center;
  column-gap: 8px;

  .${namespace}__avatar {
    width: 32px;
    height: auto;
  }
`;

export const StyledUserName = styled.div`
  ${isMobile ? 'margin-left: 10px;' : ''}
`;
